import { render, staticRenderFns } from "./CustomerSupport.vue?vue&type=template&id=fb7c49fa&"
import script from "./CustomerSupport.vue?vue&type=script&lang=js&"
export * from "./CustomerSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports